import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiService} from "@amlCore/services";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BankServiceGroupModel, BankServiceModel} from "../../model/bankService.model";

@Injectable({ providedIn: "root" })
export class BankServiceService {
  constructor(private apiService: ApiService,
              private fb: FormBuilder) {
  }


  /**
   * Получить список
   */
  getList(params: any): Observable<Array<BankServiceGroupModel>> {
    return this.apiService.get("/api/v1/qref/bankservice", params, 'id');
  }

  /**
   * Получить список по типу
   */
  getListByType(type: string): Observable<Array<BankServiceModel>> {
    return this.apiService.get(`/api/v1/qref/bankservice/listByType/${type}`);
  }

  /**
   * Получение записи по id
   * @param id - id
   */
  getBankServiceById(id: string): Observable<BankServiceModel> {
    return this.apiService.get(`/api/v1/qref/bankservice/${id}`);
  }

  /**
   * Создание/обновление
   * @param data - данные
   */
  saveBankService(data: BankServiceModel): Observable<any> {
    return this.apiService.post('/api/v1/qref/bankservice', data);
  }

  getForm(): FormGroup {
    return this.fb.group({
      id: null,
      type: [null, Validators.required],
      code: null,
      name: [null, Validators.required],
      risklevel: null
    });
  }
}
